import * as selectors from './selectors';
import { rentDetailsSlice } from './rentDetails.slice';

export const rentDetailsActions = {
  ...rentDetailsSlice.actions,
};

export const rentDetailsSelectors = {
  ...selectors,
};
